import React from 'react';
import doc from '../../../assets/app-doc.jpg'
import bg from '../../../assets/appointment-bg.jpg';

const AppointmentBanner = () => {
    return (
        <div style={{
            background: `url(${bg})`,
            backgroundSize: 'cover'
        }} class="hero min-h-screen">
            <div class="hero-content flex-col lg:flex-row-reverse">
                <img src={doc} class="max-w-sm rounded-lg shadow-2xl" alt='Dentist Chair' />
                <div>

                </div>
            </div>
        </div>
    );
};

export default AppointmentBanner;